import React from "react";
import { getImage } from "@/data/images";

export const ImageFrame = ({ filename, alt, ratio = "4/3", className = "" }) => {
  const src = getImage(filename);
  return (
    <div
      data-testid={`image-${filename.replace(/\s+/g, "-")}`}
      className={`relative w-full overflow-hidden bg-[#11151F] ${className}`}
      style={{ aspectRatio: ratio }}
    >
      {src ? (
        <img
          src={src}
          alt={alt || filename}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
        />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
          <div className="mb-3 h-px w-12 bg-[#D4A574]/40" />
          <p className="font-serif text-xs uppercase tracking-[0.22em] text-[#D4A574]/70">
            Image pending
          </p>
          <p className="mt-2 max-w-[28ch] text-[11px] leading-relaxed text-[#EDE4D3]/40">
            {filename}
          </p>
        </div>
      )}
    </div>
  );
};

export default ImageFrame;
